import { useEffect, useState } from "react";
import api from "../api/axios";
import Layout from "../components/Layout";
import Card from "../components/UI/Card";
import Button from "../components/UI/Button";
import { useTheme } from "../context/ThemeContext";

export default function ThemeSettings() {
  const { theme, loadTheme } = useTheme();
  const [activeTheme, setActiveTheme] = useState(theme.activeTheme);
  const [darkMode, setDarkMode] = useState(theme.darkMode);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    setActiveTheme(theme.activeTheme);
    setDarkMode(theme.darkMode);
  }, [theme]);

  async function save() {
    setMsg("");
    await api.put("/theme", { activeTheme, darkMode });
    await loadTheme();
    setMsg("✅ Theme updated");
  }

  const THEMES = [
    { key: "indigo",  label: "Indigo",  color: "#4f46e5" },
    { key: "emerald", label: "Emerald", color: "#10b981" },
    { key: "rose",    label: "Rose",    color: "#f43f5e" },
    { key: "slate",   label: "Slate",   color: "#64748b" },
  ];

  return (
    <Layout>
      <div className="max-w-md flex flex-col gap-5">
        <div>
          <div className="text-xs font-semibold uppercase tracking-widest opacity-40 mb-1">Appearance</div>
          <h1 className="text-2xl font-bold">Theme</h1>
          <p className="text-sm opacity-40 mt-1">Customize the look of the admin portal.</p>
        </div>

        <Card className="p-5 space-y-5">
          {/* Color swatches */}
          <div>
            <div className="text-xs font-semibold uppercase tracking-wider opacity-50 mb-3">Accent Color</div>
            <div className="grid grid-cols-2 gap-3">
              {THEMES.map(t => (
                <button
                  key={t.key}
                  onClick={() => setActiveTheme(t.key)}
                  className="flex items-center gap-3 px-4 py-3 rounded-xl border-2 transition-all text-left"
                  style={{
                    borderColor: activeTheme === t.key ? t.color : "rgb(var(--border))",
                    background: activeTheme === t.key ? `${t.color}18` : "transparent"
                  }}
                >
                  <span className="w-5 h-5 rounded-full shrink-0" style={{ background: t.color }} />
                  <span className="text-sm font-semibold">{t.label}</span>
                  {activeTheme === t.key && (
                    <span className="ml-auto text-xs font-bold" style={{ color: t.color }}>✓</span>
                  )}
                </button>
              ))}
            </div>
          </div>

          {/* Dark mode toggle */}
          <label className="flex items-center justify-between px-4 py-3.5 rounded-xl border border-[rgb(var(--border))] cursor-pointer hover:bg-[rgba(var(--primary),0.04)] transition-colors">
            <div>
              <div className="text-sm font-semibold">Dark Mode</div>
              <div className="text-xs opacity-40 mt-0.5">Switch to dark theme</div>
            </div>
            <input type="checkbox" className="toggle" checked={darkMode} onChange={() => setDarkMode(v => !v)} />
          </label>

          <div className="flex items-center gap-3 pt-1">
            <Button onClick={save}>Save Theme</Button>
            {msg && (
              <div className="text-sm text-emerald-600 bg-emerald-50 px-3 py-1 rounded-lg">{msg}</div>
            )}
          </div>
        </Card>
      </div>
    </Layout>
  );
}